import AscButton from "../../../../AscButton/AscButton";
import AscHeading from "../../../../AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../../../AscTypography/AscParagraph/AscParagraph";
import AscActivityAnswerCardForm from "../../../AscActivityAnswerCardForm/AscActivityAnswerCardForm";

import styles from "./AscActivityMarkWord.module.scss";
import AscTextArea from "../../../../AscInputFields/AscTextArea/AscTextArea";
import { useEffect } from "react";
import { useAscAddModuleActivitiesForm } from "../../useAscAddModuleActivitiesForm";
import AscTextInput from "../../../../AscInputFields/AscTextInput/AscTextInput";

export default function AscActivityMarkWord() {
  const formik = useAscAddModuleActivitiesForm();

  function addQuestion() {
    formik.setFieldValue("markWord.questions.answers", [
      ...(formik?.values?.markWord?.questions?.answers || []),
      "",
    ]);
  }

  function handleDeleteAnswer(index: number) {
    const newAnswer = [...(formik?.values?.markWord?.questions?.answers || [])];
    newAnswer.splice(index, 1);
    if (newAnswer.length === 0) {
      newAnswer.push("");
    }
    formik.setFieldValue("markWord.questions.answers", newAnswer);
  }

  useEffect(() => {
    if (!formik?.values?.markWord?.questions?.answers?.length) {
      addQuestion();
    }
  }, []);

  return (
    <div className={styles.ground}>
      <AscHeading className={styles.header} level={6}>
        Text
      </AscHeading>

      <AscParagraph className={styles.title}>Question </AscParagraph>

      <AscTextInput
        className={styles.textInput}
        name="markWord.questions.question"
        value={formik?.values?.markWord?.questions?.question}
        onChange={formik.handleChange}
      />

      <AscParagraph className={styles.title}>Full text </AscParagraph>

      <div className={styles.textEditorGround}>
        <AscTextArea
          className={styles.textarea}
          name="markWord.questions.text"
          value={formik?.values?.markWord?.questions?.text}
          onChange={formik.handleChange}
          fullWidth
        />
      </div>
      <div className={styles.titleGround}>
        <AscHeading className={styles.header} level={6}>
          Correct answers
        </AscHeading>

        <AscButton
          className={styles.link}
          variant="link"
          hideLinkIcon={true}
          onClick={addQuestion}
        >
          Add answer <span>+</span>
        </AscButton>
      </div>
      {formik?.values?.markWord?.questions?.answers?.map(
        (answer, index: number) => (
          <AscActivityAnswerCardForm
            key={index}
            name={`markWord.questions.answers[${index}]`}
            value={answer}
            onChange={formik.handleChange}
            onDelete={() => handleDeleteAnswer(index)}
            canDelete
            onBlur={formik.handleBlur}
          />
        )
      )}
    </div>
  );
}
